import Vue from 'vue';
import Vuex from 'vuex';
import merge from 'lodash/merge';
import modules from './modules';
import autosave from './plugins/autosave';
import loadFonts from './plugins/load-fonts';

Vue.use(Vuex);
// eslint-disable-next-line prefer-object-spread
const store = new Vuex.Store(
  merge(
    {
      // TODO: correctly merge plugins. autosave should go in editor module and loadFonts in settings
      plugins: [autosave, loadFonts],
    },
    ...modules,
  ),
);

export default store;
